module.exports = __webpack_public_path__ + "static/media/transfer.5a814d01.svg";